<div [matTooltip]="'Attention node'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-attention-node'"
    (click)="selectTool.emit()"
  >
    <fa-icon [icon]="['fal', 'exclamation-triangle']"></fa-icon>
  </button>
</div>
